import { render, staticRenderFns } from "./SummaryText.vue?vue&type=template&id=a3de92d0&"
import script from "./SummaryText.vue?vue&type=script&lang=js&"
export * from "./SummaryText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports